import { useMutation } from '@apollo/client';
import { useToast } from '@synoptic/ui-kit/toast/toast-provider.tsx';
import { StreamInput } from '@/__generated__/graphql.ts';
import { gql } from '@/__generated__/index.ts';
import { StreamCardFragment } from '@/components/stream-list/stream-card/stream-card-fragment.ts';

const ADD_STREAM = gql(`
  mutation AddStream($input: StreamInput!) {
    addStream(input: $input) {
      ...StreamCardFragment
    }
  }
`);

export const useAddStream = () => {
  const toast = useToast();

  const [addStreamMutation, result] = useMutation(ADD_STREAM, {
    onError: (error) => {
      toast.error({
        title: 'Failed to create stream',
        subTitle: error.message,
      });
    },
    update(cache, result) {
      const newStream = result.data?.addStream;
      if (newStream) {
        cache.modify({
          fields: {
            streamsAll(existing) {
              const newStreamRef = cache.writeFragment({
                fragment: StreamCardFragment,
                fragmentName: 'StreamCardFragment',
                data: newStream,
              });

              return {
                ...existing,
                items: [newStreamRef, ...existing.items],
              };
            },
            streamsCreated(existing) {
              const newStreamRef = cache.writeFragment({
                fragment: StreamCardFragment,
                fragmentName: 'StreamCardFragment',
                data: newStream,
              });

              return {
                ...existing,
                items: [newStreamRef, ...existing.items],
              };
            },
          },
        });
      }
    },
  });

  const addStream = (input: StreamInput) => {
    return addStreamMutation({
      variables: {
        input,
      },
    });
  };

  return [addStream, result] as const;
};
